import clsx from 'clsx'
import { useEffect, useState, type ReactNode } from 'react'

import { Chip } from '../Chip'
import type { TChipProps } from '../chip.types'

export const BouncyChip = ({ ...props }: TChipProps): ReactNode => {
  const [isFirstRender, setIsFirstRender] = useState(true)

  useEffect(() => {
    setIsFirstRender(false)
  }, [])

  return (
    <Chip
      classNames={{
        background: clsx('!ease-bounce scale-0 transition-transform duration-[1204ms]', {
          'scale-100': !isFirstRender,
        }),
      }}
      {...props}
    />
  )
}
